import { render, staticRenderFns } from "./loginBox3.vue?vue&type=template&id=85eb7852&scoped=true"
import script from "./loginBox3.vue?vue&type=script&lang=js"
export * from "./loginBox3.vue?vue&type=script&lang=js"
import style0 from "./loginBox3.vue?vue&type=style&index=0&id=85eb7852&prod&lang=scss"
import style1 from "./loginBox3.vue?vue&type=style&index=1&id=85eb7852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85eb7852",
  null
  
)

export default component.exports